<div class="div-router-outle">
	<ngx-ui-loader></ngx-ui-loader>
	<router-outlet></router-outlet>
</div>